import type { UseFormReturn } from "react-hook-form";
import { Button } from "@/components/ui/button";
import {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleContent,
} from "@/components/ui/collapsible";
import { ChevronRight, ChevronDown } from "lucide-react";
import { useState } from "react";
import { AdvancedForm } from "./advanced";
import { CreateIngredientFormData } from "./schema";
import { IngredientCategory } from "@/lib/types";
export function SimpleFormWrapper({
  children,
  form,
  selectedCategory,
}: {
  children: React.ReactNode;
  form: UseFormReturn<CreateIngredientFormData>;
  selectedCategory: IngredientCategory;
}) {
  const [isAdvancedOpen, setIsAdvancedOpen] = useState(false);
  return (
    <>
      {children}
      <Collapsible open={isAdvancedOpen} onOpenChange={setIsAdvancedOpen}>
        <CollapsibleTrigger
          render={
            <Button
              type="button"
              variant="ghost"
              className="text-muted-foreground flex items-center pl-1"
            />
          }
        >
          {isAdvancedOpen ? (
            <ChevronDown className="h-4 w-4" />
          ) : (
            <ChevronRight className="h-4 w-4" />
          )}
          <span>Advanced Properties</span>
        </CollapsibleTrigger>

        <CollapsibleContent className="space-y-2">
          <AdvancedForm
            form={form}
            isDisabled
            selectedCategory={selectedCategory}
          />
        </CollapsibleContent>
      </Collapsible>
    </>
  );
}
